module.exports = __webpack_public_path__ + "static/media/Adobe_Illustrator_CC_icon 7.b926e348.png";